import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { FindRepLink } from '../../containers/DefaultStyles/Details';

import rockTheVoteLogo from '../../assets/images/rock-the-vote-logo.png';

import { StatesAbbreviation } from '../../utils/enums';

import LegalInfo from '../Widget/LegalInfo';

import { onFindYourRep } from '../../containers/LocalRep/actions';

import {
    Sidebar,
    Title,
    SubTitle,
    NotYourRepInfo,
    Logo,
    LegalInfoWrapper
} from '../Shared/Sidebar';

const VoteRegistrationSidebar = props => (
    <Sidebar>
        <Logo src={rockTheVoteLogo} width={85} />
        {props.loadRep && <Title>{props.fullState}</Title>}
        <SubTitle>
            {props.title} {props.loadRep && props.postalCode}
        </SubTitle>
        {props.showChangeLocationLink && (
            <NotYourRepInfo>
                <FindRepLink onClick={props.onFindYourRep}>Change Location</FindRepLink>
            </NotYourRepInfo>
        )}
        {!props.isMobileResolution && (
            <LegalInfoWrapper showReceiveUpdates={props.showReceiveUpdates}>
                <LegalInfo />
            </LegalInfoWrapper>
        )}
    </Sidebar>
);

VoteRegistrationSidebar.propTypes = {
    fullState: PropTypes.string,
    postalCode: PropTypes.string.isRequired,
    isMobileResolution: PropTypes.bool,
    showChangeLocationLink: PropTypes.bool,
    onFindYourRep: PropTypes.func,
    title: PropTypes.string,
    loadRep: PropTypes.bool,
    showReceiveUpdates: PropTypes.bool
};

export default connect(
    state => {
        return {
            fullState: StatesAbbreviation[state.localRep.localRepData.state],
            postalCode:
                state.localRep.localRepData.representative !== undefined
                    ? '(' + state.localRep.localRepData.postalCode + ')'
                    : '',
            isMobileResolution: state.widget.isMobileResolution
        };
    },
    {
        onFindYourRep
    }
)(VoteRegistrationSidebar);



// WEBPACK FOOTER //
// ./src/components/VoteRegistration/VoteRegistrationSidebar.jsx